import ProgressBar from '../../components/action_plans/ProgressBar'
import { createApp } from 'vue';

if (document.getElementById('action-plan-start-page')) {
    const app = createApp({
        components: {
            ProgressBar
        },
        data() {
            return {
              action_plans: actionPlans,
              moduleId: moduleSlug,
              url: null,
              sections: []
            };
          },
        methods: {
            removeGoal(id){
                axios('/api/action-plans/remove/'+id)
                    .then(function(response){
                        this.action_plans = response.data
                    }.bind(this))
                    .catch(function(error){
                        console.error(error);
                    })
            },
            imagePath(ap) {
                let image_name = ap.goal.best_practice.section.btn_image
                let imagePath = this.$basePath+'/images/action_plans/'+ image_name;
                return imagePath;        
            }
        },
        computed: {

        },
        mounted: function () {
            this.moduleId = moduleSlug;
        }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#action-plan-start-page');
}